import React from "react";
function Folder() {
  return <></>;
}

export default Folder;
